<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Italian Prince, Wedlocked Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm02"><div class="chapterHead"><h2 class="chapterTitle0"><img alt="image" src="Images/3.jpg"/></h2></div><p class="paraCenter"><span>There are times in a man’s life…</span></p><br/><p class="paraCenter"><span><em class="italic"><span><span class="bold"><span>when only seduction will settle old scores!</span></span></span></em></span></p><br/><p class="paraCenter"><span>Pick up our exciting series of revenge-filled romances—they’re recommended and red-hot!</span></p><br/><p class="paraCenter"><span>Available only from Harlequin Presents<sup>®</sup></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// italianprincewedlockedwife_fm02.vue?1c70be50